import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "bg-modal w-maxC" }
const _hoisted_2 = { class: "row w-full" }
const _hoisted_3 = { class: "contactInputGrid mtop-15" }
const _hoisted_4 = { class: "email-form-item" }
const _hoisted_5 = { class: "main-m font-m" }
const _hoisted_6 = { class: "gcol-r mtop-035" }
const _hoisted_7 = { class: "email-form-item" }
const _hoisted_8 = { class: "main-m" }
const _hoisted_9 = {
  style: {"grid-column":"right","display":"flex","flex-direction":"column"},
  class: "row"
}
const _hoisted_10 = {
  key: 0,
  class: "error-message"
}
const _hoisted_11 = { class: "mtop-10 email-form-item" }
const _hoisted_12 = { class: "main-m" }
const _hoisted_13 = { style: {"grid-column":"right"} }

import { ref, computed, type PropType, onMounted } from 'vue';
import { useUiStore } from '@/stores/ui';
import { InstituteEmailRequest, UpdateEmailPwrRequest } from '@/apiGenerate/medserver';
import { useI18n } from 'vue-i18n';
import { Regex } from '@/models/share.model';
import ToggleSwitch from "primevue/toggleswitch";

type OwnerType = 'patient' | 'healthGroup' | 'institute'


export default /*@__PURE__*/_defineComponent({
  __name: 'emailInput',
  props: {
  email: {
    type: Object,
    required: false,
  },
  pwr: {
    type: Object,
    required: false,
  },
  iwr: {
    type: Object,
    required: false,
  },
  ownerType: {
    type: String as PropType<OwnerType>,
    required: true,
  },
  isUpdate: {
    type: Boolean,
    required: false,
    default: false
  }
},
  emits: ['close', 'update-person-email', 'update-institute-email', 'delete-person-email', 'delete-institute-email', 'create-person-email', 'create-institute-email'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();
const uiStore = useUiStore()
const emailError = ref(false);

const props = __props;

const emits = __emit;
const focusRef = ref(null);

const isInstitute = computed(() => props.ownerType === 'institute');

const showPreferred = computed(() => {
  if (props.ownerType === 'patient') {
    return uiStore.adminDashBoardView === 'dashbPatient'
  }
  if (props.ownerType === 'institute') {
    return true
  }
  return false
})

const showNote = computed(() => !isInstitute.value);

const isPreferredEmail = ref<boolean>(props.email?.isPreferred);

const emailAddressInput = ref<string>(props.email?.email || '');

async function updateEmail() { 
  if (isInstitute.value && props.iwr) {
    const instituteEmailRequest: InstituteEmailRequest = {
        email: emailAddressInput.value
    };

    emits('update-institute-email', instituteEmailRequest);    
  } else {
    const updateEmailPwrRequest: UpdateEmailPwrRequest = {
        email: emailAddressInput.value,
        note: emailNoteInput.value,
        isFavorite: isPreferredEmail.value
    };
    emits('update-person-email', updateEmailPwrRequest);
  }
}

const emailNoteInput = ref(props.email?.note || '');

async function deleteEmail() {
  if (!props.email) return;
  emits('close');

  if (isInstitute.value) {
    emits('delete-institute-email');
  } else {
    emits('delete-person-email');
  }
}

const closeFormModal = () => {
  const emailAddress = emailAddressInput.value;
  if (!Regex.emailFormat.test(emailAddress)) {
    emailError.value = true;

    throw t('patient.admin.invalidEmail');
  } else {
    if (props.isUpdate) {
      updateEmail();
    } else {
      emailError.value = false;
      if (props.email) return
        const note = emailNoteInput.value;
        emits('close');

        if (isInstitute.value) {
          emits('create-institute-email', emailAddress);
        } else {
          emits('create-person-email', {email: emailAddress, note: note});
        }
      }
    }
}

onMounted(() => {
  focusRef.value.innerRef.focus();
})

return (_ctx: any,_cache: any) => {
  const _component_es_modal_header = _resolveComponent("es-modal-header")!
  const _component_inputLineNew2 = _resolveComponent("inputLineNew2")!
  const _component_inputBox = _resolveComponent("inputBox")!
  const _component_inputAreaAuto2 = _resolveComponent("inputAreaAuto2")!
  const _component_es_modal_footer = _resolveComponent("es-modal-footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_es_modal_header, {
        header: _unref(t)('common.contactForm.title.email'),
        "display-delete": !!props.email,
        "label-delete": _unref(t)('action.delete'),
        "confirm-method": deleteEmail
      }, null, 8, ["header", "display-delete", "label-delete"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (props.email && showPreferred.value && !isInstitute.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)('common.contactForm.label.email.isDefault')), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_unref(ToggleSwitch), {
                modelValue: isPreferredEmail.value,
                "onUpdate:modelValue": [
                  _cache[0] || (_cache[0] = ($event: any) => ((isPreferredEmail).value = $event)),
                  _cache[1] || (_cache[1] = ($event: any) => (isPreferredEmail.value = $event))
                ]
              }, null, 8, ["modelValue"])
            ])
          ], 64))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)('settings.params.account.details.email')), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_inputBox, null, {
          default: _withCtx(() => [
            _createVNode(_component_inputLineNew2, {
              ref_key: "focusRef",
              ref: focusRef,
              modelValue: emailAddressInput.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((emailAddressInput).value = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        (emailError.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_unref(t)('patient.admin.invalidEmail')), 1))
          : _createCommentVNode("", true)
      ]),
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "row w-full mtop-10" }, null, -1)),
      (showNote.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(t)('settings.params.account.details.note')), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_inputBox, null, {
                default: _withCtx(() => [
                  _createVNode(_component_inputAreaAuto2, {
                    modelValue: emailNoteInput.value,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((emailNoteInput).value = $event)),
                    lines: 3
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_es_modal_footer, {
      onModalCancel: _cache[4] || (_cache[4] = ($event: any) => (emits('close'))),
      "confirm-modal-method": closeFormModal,
      class: "mtop-12"
    })
  ]))
}
}

})